<template>
	<div class="advanced-keyword-detail">
		<el-form ref="form" :model="form" :rules="rules" label-width="120px">
			<el-form-item label="规则名称：" prop="rulename">
				<el-input placeholder="请输入规则名称" v-model="form.rulename" clearable>
				</el-input>
			</el-form-item>
			<el-form-item v-for="(item, index) in form.rulesKeyList" label="关键词" :key="'rulesKeyList.' + index"
				:prop="'rulesKeyList.' + index + '.keysValue'" :rules="{
			      required: true, message: '请输入关键词', trigger: 'blur'
			    }">
				<el-input placeholder="请输入内容" v-model="item.keysValue" style="width:80%" maxlength="30" show-word-limit>
					<el-select v-model="item.matchType" slot="prepend" placeholder="请选择" style="width: 100px;">
						<el-option label="半匹配" value="1"></el-option>
						<el-option label="全匹配" value="2"></el-option>
					</el-select>
				</el-input>
				<div style="display: inline-block;margin-left: 5px;">
					<el-button type="text" @click.prevent="onAdd(item,index,'keyword')" v-show="index == form.rulesKeyList.length - 1">添加</el-button>
					<el-button type="text" @click.prevent="onRemove(item,index,'keyword')" v-show="form.rulesKeyList.length > 1">删除</el-button>
				</div>
			</el-form-item>
			<el-form-item v-for="(item, index) in form.rulesResponseList" label="回复内容" :key="'rulesResponseList.' + index"
				:prop="'rulesResponseList.' + index + '.response'" :rules="{
			      required: true, message:item.responseType =='text'?'请输入回复内容':'请选择', trigger: item.responseType =='text'? 'blur' :'change'
			    }">
				<el-select v-model="item.responseType" placeholder="请选择" style="width: 100px;display: block;" @change="(val) => onResponseType(val,index)">
					<el-option label="文本" value="text"></el-option>
					<el-option label="IM" value="im" :disabled="getDisabled"></el-option>
				</el-select>
				<template v-if="item.responseType == 'text'">
					<el-input placeholder="请输入回复内容" type="textarea" v-model="item.response" style="width:80%;margin-top: 5px;" maxlength="300" show-word-limit></el-input>
				</template>
				<template v-else>
					<div style="margin-top: 10px;" v-show="item.editable">
						<el-select v-model="form.brand" clearable placeholder="请选择授权品牌" @change="() => onBrandChange(index)">
							<el-option v-for="item in brand_options" :key="item.id" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
					<div style="margin-top: 10px;" v-show="item.editable">
						<el-select v-model="form.skillGroup" clearable placeholder="请选择技能组" @change="() => onSkillChange(index)">
							<el-option v-for="item in skillGroup_options" :key="item.skillId" :label="item.skillName"
								:value="item.skillId">
							</el-option>
						</el-select>
					</div>
					<el-input style="margin-top: 10px;" v-model="item.response"  v-show="!item.editable">
						  <el-button slot="append" icon="el-icon-edit" @click="onEditResponseIm(item)"></el-button>
					</el-input>
				</template>
				<div style="display: inline-block;margin-left: 5px;">
					<el-button type="text" @click.prevent="onAdd(item,index,'response')" v-show="index == form.rulesResponseList.length - 1">添加</el-button>
					<el-button type="text" @click.prevent="onRemove(item,index,'response')" v-show="form.rulesResponseList.length > 1">删除</el-button>
				</div>
			</el-form-item>
			<el-collapse >
				  <el-collapse-item title="高级属性" name="1">
					<el-form-item label="服务名：" prop="service">
						<el-input placeholder="请输入服务名" v-model="form.service" clearable>
						</el-input>
					</el-form-item>
					<el-form-item label="方法名：" prop="method">
						<el-input placeholder="请输入方法名" v-model="form.method" clearable>
						</el-input>
					</el-form-item>
				  </el-collapse-item>
			  </el-collapse>
		</el-form>
		<div class="footer">
			<el-button @click="onCancel" size="mini">取 消</el-button>
			<el-button type="primary" size="mini" @click="onSubmit" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}
			</el-button>
		</div>
	</div>
</template>

<script>
	import {mapGetters} from 'vuex';
	export default {
		computed:{
			 ...mapGetters([
				'subBrandList',
			]),
			getDisabled(){
				const index = this.form.rulesResponseList.findIndex((el) => el.responseType == 'im');
				if(index == -1) return false
				 return true
			}
		},
		props:{
			detailViewer:{
				default:''
			}
		},
		watch:{
			'detailViewer':{
				handler(value){
					if(value){
						this.$nextTick(() => {
							this.$refs.form.resetFields();
						})
						this.getBrand();
						if(value.source){
							this.geInfos();
						}
					}
					
				},
				deep:true,
				immediate:true
			}
			
		},
		data(){
			return {
				skillGroup_options:[],
				brand_options:[],
				loading:false,
				form:{
					appid:'',
					rulename:'',
					skillGroup:'',
					brand: '',
					service:'',
					method:'',
					rulesKeyList:[
						{
							keysValue: '',
							matchType: '1',
							orderno:0
						}
					],
					rulesResponseList:[{
						orderno:0,
						response:'',
						responseType:'text',//im
						editable:false,
					}]
					
				},
				rules:{
					rulename: [{
						required: true,
						message: '请输入规则名称',
						trigger: 'blur'
					}]
				}
			}
		},
		methods:{
			onSubmit(){
				this.form.appid = this.detailViewer.parentSource.weiboId;
				 this.$refs['form'].validate((valid) => {
					 if(valid){
						 this.loading = true;
						if(this.detailViewer.source){
							this.form.id = this.detailViewer.source.id;
							this.$api.updateWeiboKeywordForSystem(this.form).then(res => {
								this.loading = false;
								if(res.errcode != 0) return;
								this.$notify.success('编辑成功');
								this.$emit('onSubmit')
							})
						}else {
							this.$api.addWeiboKeywordForSystem(this.form).then(res => {
								this.loading = false;
								if(res.errcode != 0) return;
								this.$notify.success('添加成功');
								this.$emit('onSubmit')
							})
						}
					 }
				 })
			},
			onAdd(row,index,key){
				switch (key){
					case 'keyword':
						 this.form.rulesKeyList.push({
							  keysValue: '',
							  matchType: '1',
							  orderno:this.form.rulesKeyList.length
						});
						break;
					default:
						 this.form.rulesResponseList.push({
							response:'',
							responseType:'text',
							orderno:this.form.rulesResponseList.length
						});
						break;
				}
			},
			onRemove(row,index,key){
				switch (key){
					case 'keyword':
						 this.form['rulesKeyList'].splice(index, 1);
						break;
					default:
						this.form['rulesResponseList'].splice(index, 1);
						break;
				}
			},
			onEditResponseIm(row){
				row.editable = true;
				this.$forceUpdate();
			},
			// 根据id查询详情
			geInfos(){
				let infos = JSON.parse(JSON.stringify(this.detailViewer.source));
				Object.keys(this.form).map(key => {
					this.form[key] = infos[key];
				})
			},
			onCancel(){
				this.$emit('onCancel')
			},
			onResponseType(val,index){
				this.form.rulesResponseList[index].response = '';
				if(val == 'im') {
					this.form.brand = '';
					this.form.skillGroup = '';
					this.form.rulesResponseList[index].editable = true;
				}
			},
			onBrandChange(){
				if(this.form.brand){
					this.getSkillgroupList({
						brand:this.form.brand,
					})
					return;
				}
				this.skillGroup_options = [];
				this.form.skillGroup = '';
			},
			onSkillChange(index){
				if(this.form.skillGroup && this.form.brand){
					this.$api.apiAcceptAuthForSystem(this.detailViewer.parentSource.weiboId,{
						brand:this.form.brand,
						skillGroup:this.form.skillGroup,
						channel:'weibo'
					}).then(res => {
						if(res.errcode != 0) return;
						this.form.rulesResponseList[index].response = JSON.parse(res.data).imUrl;
						this.form.rulesResponseList[index].editable = false;
					})
					return
				}
				this.form.rulesResponseList[index].response = '';
			},
			// 获取可选技能组列表
			async getSkillgroupList(value){
				this.$api.getWechatSystemSkillGroup({brand:value.brand,appid:this.detailViewer.parentSource.weiboId}).then(res => {
					this.skillGroup_options = res.data;
					this.form.skillGroup = '';
				})
			},
			// 获取可选子品牌列表
			async getBrand(){
				 this.brand_options = await this.subBrandList;
			},
		}
	}
</script>

<style lang="scss" scoped>
	.advanced-keyword-detail {
		.footer {
			text-align: right;
			margin: 20px 0;
		}
		.el-collapse {
			padding: 0 20px 20px 20px;
			border: none;
		}
	}
</style>